import { render } from "./Categories.vue?vue&type=template&id=f8318e74&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=f8318e74&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8318e74"]])

export default __exports__